import { observable, action, computed } from 'mobx';
import { MODE } from './step';
import { compareVersion } from '../../js/utils';

// TODO 查询babel-polyfill是否支持Map，用Map结构更好
export const modes = {
  10: {
    desc: '生产'
  },
  20: {
    desc: '仓储'
  },
  30: {
    desc: '安装'
  },
  40: {
    desc: '冬眠'
  },
  '50-60': {
    desc: '工作'
  },
  60: {
    desc: '休眠'
  }
};

const themeType = localStorage.getItem('themeType') || 'light';

export const operateModes = [
  {
    desc: '自动模式',
    headerColor: themeType === 'dark' ? '#000000' : '#f2f2f2',
    headerFontColor: themeType === 'dark' ? '#fff' : '#333',
    fontColor: themeType === 'dark' ? '#fff' : '#333',
    mode: MODE.AUTO,
    bgColor: themeType === 'dark' ? '#000000' : '#fff',
  },
  {
    desc: '一般模式',
    headerColor: '#409EFF',
    headerFontColor: '#fff',
    fontColor: '#000',
    mode: MODE.NORMAL,
    bgColor: '#ffffff'
  },
  {
    desc: '专家模式',
    headerColor: themeType === 'dark' ? '#000000' : '#f2f2f2',
    headerFontColor: themeType === 'dark' ? '#fff' : '#333',
    fontColor: themeType === 'dark' ? '#fff' : '#333',
    mode: MODE.EXPERT,
    bgColor: themeType === 'dark' ? '#000000' : '#fff',
  },
  {
    desc: '检测模式',
    headerColor: '#4981ff',
    headerFontColor: '#fff',
    fontColor: '#000',
    mode: MODE.DETECT,
    bgColor: '#f2f2f2',
    contentClass: 'detect-content'
  }
];

export const theme = {
  dark: {
    desc: '深色',
    headerColor: '#000000',
    headerFontColor: '#fff',
    fontColor: '#fff',
    mode: 'dark',
    bgColor: '#000000',
    showLocationIcon: 'automatic'
  },
  light: {
    desc: '浅色',
    headerColor: '#f2f2f2',
    headerFontColor: '#333',
    fontColor: '#333',
    mode: 'light',
    bgColor: '#fff',
    showLocationIcon: 'detect'
  }
};

export default class GlobalStore {
  // 当前模式
  @observable mode = null;

  // 是否初始化雷达，从255页读取
  @observable isInitRadar = true;

  // 重试蓝牙重连
  @observable retryConnectBle = true;

  @observable quickDetect = false;

  // 当前模式描述信息
  @observable modeDesc = '未知';

  // 地磁工作状态： 通信（上传云端数据）、检测、休眠
  @observable geoWorkState = '工作';

  // 蓝牙是否已连接
  @observable btOnConnect = false;

  // 用于安装调试界面模式切换
  @observable operateMode = MODE.AUTO;

  // 安装调试状态（新版安装调试界面）
  @observable status = 'default';

  // 当前调试进程
  @observable currentProcess = '';

  // 当前调试进度百分比
  @observable processRate = 0;

  // cpu1 版本号
  @observable version = null;

  // cfgMagbaseEn 值 大于1跳过初始化雷达和初始化地磁
  @observable cfgMagbaseEn = 0;

  // 手持机检测状态
  @observable handsetDetectState = null;

  // 手持机检测时间
  @observable handsetDetectTime = null;

  // 手持机检测与地磁检测的时间差
  @observable handsetDetectDelayTime = null;

  // 手持机主题模式 dark：深色 light：浅色
  @observable themeType = localStorage.getItem('themeType') || 'light';

  @action geMode() {
    return modes[this.mode].desc;
  }

  @action setMode(mode) {
    if (!mode) {
      this.mode = null;
      this.modeDesc = '未知';
      return;
    }

    const reveiveMode = mode.toString();
    if (reveiveMode === this.mode) return;

    // eslint-disable-next-line no-restricted-syntax
    for (const key in modes) {
      if (Object.prototype.hasOwnProperty.call(modes, key)) {
        const k = key.split('-');
        let flag = false;

        if (k.length > 1) {
          if (reveiveMode >= k[0] && reveiveMode < k[1]) {
            flag = true;
          }
        } else if (reveiveMode === key) {
          flag = true;
          this.mode = reveiveMode;
          this.modeDesc = modes[key].desc;
        }

        if (flag) {
          this.mode = reveiveMode;
          this.modeDesc = modes[key].desc;
          break;
        }
      }
    }
  }

  @computed get canSetDetectSpeed() {
    if (!this.version) {
      return false;
    }
    const version = this.version.replace(/[^0-9.]/g, '');
    return compareVersion(version, '6.72') || version === '6.72';
  }

  @action reset() {
    this.mode = null;
    this.modeDesc = '未知';
    this.geoWorkState = '未知';
    this.status = 'default';
    this.currentProcess = '';
    this.processRate = 0;
    this.handsetDetectState = null;
    this.handsetDetectTime = null;
    this.handsetDetectDelayTime = null;
  }
}

export const globalStore = new GlobalStore();
